import { FieldWrapper, Textarea } from '@dixa/lib-shared-habla';
import { Controller, FieldValues } from 'react-hook-form';

import { getFieldMeta } from '../../utils';

import { FieldInputTextProps } from './fieldInputText';

type FieldInputTextAreaProps<T extends FieldValues> = FieldInputTextProps<T> & {
  height: string | number;
  width: string | number;
};
/** React Hook Form input component wrapped within a Habla FieldWrapper */
export function FieldInputTextArea<T extends FieldValues>({
  control,
  name,
  label,
  placeholder,
  required,
  description,
  helpIcon,
  height,
  width,
  disabled,
}: FieldInputTextAreaProps<T>): JSX.Element {
  return (
    <Controller
      control={control}
      name={name}
      render={({ field, fieldState }) => {
        const { ref, ...fieldWithoutRef } = field;
        const meta = getFieldMeta(fieldState);
        return (
          <FieldWrapper
            label={label}
            required={required}
            meta={meta}
            description={description}
            helpIcon={helpIcon}
          >
            <Textarea
              style={{ width, height, minHeight: height, resize: 'vertical' }}
              {...fieldWithoutRef}
              placeholder={placeholder}
              disabled={disabled}
            />
          </FieldWrapper>
        );
      }}
    />
  );
}
